import type { Location } from "@/types/Location"

class Address {
  id: number
  title: string
  street: string
  houseNumber: string
  zipcode: string
  city: string
  coordinates: { lat: number; lng: number }
  country: string

  constructor(address: any) {
    this.id = address.id
    this.title = address.attributes.title
    this.street = address.attributes.street_name
    this.houseNumber = address.attributes.street_number
    this.zipcode = address.attributes.zipcode
    this.city = address.attributes.city
    this.coordinates = address.attributes.coordinate
    this.country = address.attributes.country.code.toLowerCase()
  }
}

const addressToLocation = (address: Address): Location => {
  return {
    city: address.city,
    coordinates: { lat: address.coordinates.lat, lng: address.coordinates.lng },
    country: address.country,
    houseNumber: address.houseNumber,
    id: address.id,
    street: address.street,
    title: address.title,
    zipcode: address.zipcode,
  }
}

export { Address, addressToLocation }
